var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"landing"}},[_c('SectionUseful'),_c('SectionNeeds'),_c('SectionAsapLoan'),_c('SectionLoanFee'),_c('SectionFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }